<template>
  <div class="wg-row">
    <!-- Modal per l'aggiunta di un messaggio -->
    <wg-modal
      v-if="showNewContentDialog"
      :width="windowWidth > 700 ? '700px' : '90%'"
      @closeModal="showNewContentDialog = false"
      :confirmOnClose="true"
      :confirmOnCloseMsg="$anm22.strLang(lang, 'Cancel adding a new feed?', 'Annullare aggiunta feed?')"
    >
      <div
        class="com-anm22-app-text-l"
        slot="header"
      >{{ $anm22.strLang(lang, 'Add content', 'Aggiungi elemento') }}</div>
      <new-feed-dialog slot="body" :contactId="contact.idContactsContact"></new-feed-dialog>
    </wg-modal>
     <div v-if="msgs.length === 0" style="margin:auto;">
        <img src="@/assets/question_answer_black.svg" style="width:60px;display:block;margin:20px auto;opacity:0.3" />
        <div style="text-align:center;max-width:400px;font-size:16px;color:#666;margin:0 auto;">{{ $anm22.strLang(lang, "No feed", "Nessun feed") }}</div>
        <div style="text-align:center;max-width:400px;font-size:14px;color:#999;margin:0 auto 50px auto;">{{ $anm22.strLang(lang, "Create your first feed", "Crea il tuo primo feed") }}</div>
     </div>
    <div v-else class="wg-row feed-container">
      <!-- Visualizzazione messaggi del feed -->
      <template v-for="(msg, index) in msgs">
        <!-- Controllo se è cambiato giorno -->
        <div
          :key="'sep'+index"
          v-if="index === 0 || $moment.unix(msg.ts).isAfter($moment.unix(msgs[index - 1].ts), 'day')"
          class="wg-row day-sep"
        >
          {{
          $moment.unix(msg.ts).isSame(now, 'day')
          ? $anm22.strLang(lang, 'Today', 'Oggi')
          : ($moment.unix(msg.ts).isSame(now, 'year') ? $moment.unix(msg.ts).format('DD MMM') : $moment.unix(msg.ts).format('DD MMM YYYY'))
          }}
        </div>
        <div class="wg-row" :ref="'msgToScroll-'+index" :key="'msg-'+index">
          <contact-feed-msg
            :msg="msg"
            :contactId="contact.idContactsContact"
            :sameUser="index > 0 ? msg.user !== msgs[index - 1].user : true"
          ></contact-feed-msg>
        </div>
      </template>
      <div class="vertical-height-div" style="height:127px;"></div>
    </div>
    <!-- Floating button per l'aggiunta -->
    <wg-fab
      style="position:fixed;bottom:30px;right:30px;"
      :icon="$anm22.icons.getWorldIcon('addWhite')"
      :bgColor="'rgb(10, 171, 244)'"
      :click="() => showNewContentDialog = true"
    ></wg-fab>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Spinner from "vue-simple-spinner";
import NewFeedDialog from "./NewFeedDialog.vue";
import ContactFeedMsg from "./ContactFeedMsg.vue";

export default {
  props: {
    contactId: [String, Number]
  },
  data() {
    return {
      loading: false,
      now: this.$moment(),
      lastCheck: null,
      temp: null,
      updateInterval: null,
      showNewContentDialog: false
    };
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      lang: state => state.lang,
      windowWidth: state => state.windowWidth
    }),
    contact() {
      return this.$store.getters["contacts/get"](this.contactId);
    },
    permission() {
      if (this.contact.workOwner) {
        return this.$store.getters["employments/getPermByWork"](
          this.contact.workOwner
        );
      } else {
        return 1;
      }
    },
    feed() {
      return this.$store.getters["messageChannels/get"](this.contact.feed);
    },
    msgs() {
      return this.feed
        ? this.$store.getters["messages/getByChannel"](
            this.feed.idWorldMessageChannel
          ).sort((a, b) => a.ts - b.ts)
        : [];
    }
  },
  methods: {
    loadData() {
      Promise.all([
        this.$store.dispatch(
          "messageChannels/load",
          this.$vlf("messageChannels")
        ),
        this.$store.dispatch(
          "feedBoardAssocs/load",
          this.$vlf("feedBoardAssocs")
        ),
        this.$store.dispatch("messages/load", this.$vlf("messages"))
      ])
        .then(() => {
          this.loading = false;
        })
        .catch(error => console.log(error));
    },
    checkUpdates() {
      // if(!this.$store.getters['offline/isOffline'] && this.board){
      //   this.$http.get('project/checkMessages?idProject='+this.project.idWorldProject+'&ts='+this.lastCheck.utc().format('X'))
      //   .then(response => {
      //     this.lastCheck = this.$moment();
      //     return this.$store.dispatch('messages/update',
      //       { vlf: this.$vlf('messages'), objs: response.data.messages }
      //     );
      //   })
      //   .then(() => {
      //     this.lastIndex = this.msgs.length;
      //   })
      //   .catch(error => console.log(error));
      // }
    },
    /* Carico altri 20 elementi passati */
    loadMore() {}
  },
  created() {
    this.loading = true;
    this.loadData();
    //Load feed and messages
    this.$http
      .get("contact/feed?idContact=" + this.contact.idContactsContact)
      .then(response => {
        this.lastCheck = this.$moment();
        if (response.data) {
          Promise.all([
            this.$store.dispatch("messageChannels/update", {
              vlf: this.$vlf("messageChannels"),
              objs: [response.data.feed]
            }),
            this.$store.dispatch("messages/update", {
              vlf: this.$vlf("messages"),
              objs: response.data.messages,
              cleanFilters:[m=> m.channel == response.data.feed.idWorldMessageChannel]
            }),
            this.$store.dispatch("feedBoardAssocs/update", {
              vlf: this.$vlf("feedBoardAssocs"),
              objs: response.data.assocs
            })
          ])
            .then(() => {
              this.loading = false;
              if (this.msgs.length != 0) {
                this.$refs[
                  "msgToScroll-" + parseInt(this.msgs.length - 1)
                ][0].scrollIntoView();
              }
            })
            .catch(error => console.log(error));
        }
      })
      .catch(error => console.log(error));
  },
  mounted() {
    this.$nextTick(() => {
      this.updateInterval = setInterval(this.checkUpdates, 10000);
    });
  },
  destroyed() {
    clearInterval(this.updateInterval);
  },
  components: {
    "vue-simple-spinner": Spinner,
    NewFeedDialog,
    ContactFeedMsg
  }
};
</script>

<style lang="scss" scoped>
.feed-container {
  overflow: auto;
  height: 100%;
  width: 100%;
  padding-right: 3px;
  &::-webkit-scrollbar {
    width: 10px;
    min-height: 10px;
    height: 10px;
  }
  &::-webkit-scrollbar-track {
    opacity: 0;
    width: 10px;
    min-height: 10px;
    height: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #78909c;
    border: 3px solid transparent;
    border-radius: 9px;
    background-clip: content-box;
  }
}
.day-sep {
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  margin: 30px 0 5px 0;
  font-size: 14px;
  color:#999;
  text-transform: uppercase;
  font-weight: bold;
}
</style>
